import { useCallback } from "react";
import { ViewsApi, useAPIAction } from "melco-shared-logic";

export const useDeleteViews = () => {
  const [deleteView] = useAPIAction(
    ViewsApi,
    async (api: ViewsApi, id: string) => {
      const data = await api.statisticalViewDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "reporting.machinestatus.view.actions.delete",
    }
  );

  return useCallback(
    async (viewIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const viewId of viewIds) {
        try {
          await deleteView(viewId);
          successfullyDeleted.push(viewId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteView]
  );
};
